<template>
    <v-dialog
    v-model="isShowTerms"
        persistent
        transition="dialog-bottom-transition"
        max-width="70vw"
        :content-class="isDarkMode ? 'dark-mode' : ''"
        >
        <template v-slot:default="dialog">
            <v-card>
                <v-card-title class="bg-grey mb-2">
                    <span>Yazam MFT's Terms of Use</span>
                </v-card-title>
                <v-card-text>
                    <TermsOfUse />
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <Button
                    text="Close"
                    :clickAction="closeTermsOfUse"
                    btnType="grey"
                    />
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
    </template>

    <script>
import TermsOfUse from '@/components/BaseComponents/TermsOfUse/TermsOfUse.vue'
import Button from '@/components/BaseComponents/Button/Button.vue'
export default {
    name: 'TermsOfUseDialog',
    data() {
        return {
            isShowTerms: true,
        }
    },
    components: { TermsOfUse, Button },
    props: {
        closeTermsOfUse: Function,
    },
}
</script>